module.exports = __webpack_public_path__ + "img/bottom-right-corner.4cb4cc16.svg";